import * as constants from "../constants/HBConstants";

const defaultState = {
  login_token: "",
  loading: false,
};

const HBReducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.HB_GET_URL_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case constants.HB_GET_URL_SUCCEEDED:
      return {
        ...state,
        login_token: data.login_token,
        loading: false,
      };
    case constants.HB_GET_URL_FAILED:
      return defaultState;
    default:
      return state;
  }
};

export default HBReducer;